import { IQuoteBehavior, IQuoteBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanQuotable } from "../../../beans/objects";

export class QuoteBehaviorTranslator {
  from(bean: IObjectBeanQuotable): IQuoteBehavior {
    return {
      isEnable: (bean["@quote"] !== "0"),
    };
  }

  to(o: IQuoteBehaviorSpecifiable) {
    return {
      quote: o.quoteBehavior.isEnable
        ? undefined
        : "0",
    };
  }
}
